module.exports = __webpack_public_path__ + "static/media/Splash.8db18c66.png";